import { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import { Icon, IconButton, Modal } from '@mui/material';
import './DataSourceModal.css';

export default function DataSourceModal() {
	const { dataSourceOpen, setDataSourceOpen } = useContext(AppContext);

	return (
		<Modal open={dataSourceOpen} onClose={() => setDataSourceOpen(false)}>
			<section className="centerModal" tabIndex="-1">
				<div className="header">
					<img src="img/iconQuest.png" className="titIcon" alt="iconQuest" />
					<h1>데이터 출처 및 유의사항</h1>
					<IconButton
						className="closeIconButton"
						onClick={() => {
							console.log('prev');
							setDataSourceOpen(false);
							console.log('next');
						}}
						size="large"
					>
						<Icon className="closeIcon">close</Icon>
					</IconButton>
				</div>
				<div className="body">
					<h2>● 데이터 출처</h2>
					<table className="smTable">
						<thead>
							<tr>
								<th>구분</th>
								<th colSpan="2">
									분석 데이터명
								</th>
								<th>단위</th>
								<th>기준년도</th>
								<th>출처</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>인구</td>
								<td>연령대별인구</td>
								<td>5세별 인구수</td>
								<td>Polygon(1km × 1km 격자)</td>
								<td rowSpan="3">2021</td>
								<td rowSpan="3">
									SGIS(통계청)
									<br />
									<span className="smText">·인구주택총조사</span>
								</td>
							</tr>
							<tr>
								<td rowSpan="2">가구</td>
								<td>총가구</td>
								<td>총가구수</td>
								<td rowSpan="2">Polygon(1km × 1km 격자)</td>
							</tr>
							<tr>
								<td>세대구성별</td>
								<td>1인가구</td>
							</tr>

							<tr>
								<td rowSpan="5">
									주요
									<br />
									시설
								</td>
								<td colSpan="2">행정복지센터</td>
								<td>Point</td>
								<td rowSpan="4">2022</td>
								<td>
									도로명주소 안내시스템
								</td>
							</tr>
							<tr>
								<td colSpan="2">
									병·의원<span className="smText">(종합병원 포함)</span>
								</td>
								<td>Point</td>
								<td>건강보험심사평가원</td>
							</tr>
							<tr>
								<td colSpan="2">
									경찰서<span className="smText">(지구대, 파출소 포함)</span>
								</td>
								<td>Point</td>
								<td>
									도로명주소 안내시스템
								</td>
							</tr>
							<tr>
								<td colSpan="2">산업단지</td>
								<td>Polygon</td>
								<td>브이월드</td>
							</tr>
							<tr>
								<td colSpan="2">대학교</td>
								<td>Point</td>
								<td>2023</td>
								<td>KESS 교육통계서비스</td>
							</tr>
						</tbody>
					</table>

					<h2>● 유의사항 (출처: 통계청)</h2>
					<div className="cautionCont">
						<p>
							분석에 사용되는 원데이터 특성상 결과 해석 시 다음 사항들을 고려해야 합니다.
						</p>

						<p className="depth2 depth2Fix">
							· SGIS 격자 단위 가구 데이터(총가구, 1인가구)의 경우 가구의
							인구속성(연령대, 성별 등)이 제공되지 않습니다.
							<span className="smText2">
								예시&#41; 1인가구가 몰려 있는 지역의 해당 1인가구 연령은 SGIS
								격자단위 가구데이터로는 파악할 수 없음{' '}
							</span>
						</p>
						<p className="depth2">
							· SGIS 격자 단위 1인가구 데이터에는 &lsquo;집단가구(기숙사,
							노인요양시설 등)&rsquo;이 포함되지 않습니다.
						</p>
						<p className="depth2" style={{flexDirection: "column", alignItems: "flex-start"}}>
							· SGIS 격자 데이터는 개인정보보호를 위해 아래와 같이 통계청 비밀보호기법이
							적용되어 제공되는 값이 실제 값과 다를 수 있습니다. 
							<span className='smText2'>
								- 제공되는 값이 0인 경우: 실제 값은 0, 1, 2, 3, 4 중 하나
							</span>
							<span className='smText2'>
								- 제공되는 값이 5인 경우: 실제 값은 1, 2, 3, 4, 5 중 하나
							</span>
							<span className='smText2'>
								- 제공되는 값이 6 이상의 값 M인 경우: 실제 값은 M-2 ~ M+2 중 하나(일부 자료 M-7 ~ M+7)
								<span className='depth2'>예시&#41; 인구 값 200은 실제 값 198~202 중 하나임</span>
							</span>
						</p>
					</div>
				</div>
			</section>
		</Modal>
	);
}
